"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _TimezoneContext = require("../_contexts/TimezoneContext");
/** This hook should be used when we want to do something when the timezone
 * changes (e.g. from the timezone switcher in the page).
 * This hook needs to be used at the highest level where we employ the timezone
 * context, because if the parent component re-renders we will be getting the
 * same value for the ref (timezone).
 *
 * @param {function} callback : a function to be called when timezone changes. Important: this function should be memoized.
 */

var useRespondToTimezoneChange = function useRespondToTimezoneChange(callback) {
  var _useTimezone = (0, _TimezoneContext.useTimezone)(),
    timezone = _useTimezone.timezone;
  var prevTimezoneRef = (0, _react.useRef)(timezone);

  // update the state when the timezone changes
  (0, _react.useEffect)(function () {
    // make sure it's a timezone change
    // this is only necessary if user would be able to change the isEndOfDay prop
    if (!timezone || prevTimezoneRef.current === timezone) {
      return;
    }

    // update the ref
    prevTimezoneRef.current = timezone;
    callback();
  }, [timezone, prevTimezoneRef, callback]);
};
var _default = useRespondToTimezoneChange;
exports["default"] = _default;